import { emptySplitApi as api } from "../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiAdminV1EmployeeRecordValuesList: build.query<
      ApiAdminV1EmployeeRecordValuesListApiResponse,
      ApiAdminV1EmployeeRecordValuesListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/employee-record-values/`,
        params: {
          organization_id: queryArg.organizationId,
        },
      }),
    }),
    apiAdminV1EmployeeRecordValuesCreate: build.mutation<
      ApiAdminV1EmployeeRecordValuesCreateApiResponse,
      ApiAdminV1EmployeeRecordValuesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/employee-record-values/`,
        method: "POST",
        body: queryArg.employeeRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1EmployeeRecordValuesRetrieve: build.query<
      ApiAdminV1EmployeeRecordValuesRetrieveApiResponse,
      ApiAdminV1EmployeeRecordValuesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/employee-record-values/${queryArg.id}/`,
      }),
    }),
    apiAdminV1EmployeeRecordValuesUpdate: build.mutation<
      ApiAdminV1EmployeeRecordValuesUpdateApiResponse,
      ApiAdminV1EmployeeRecordValuesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/employee-record-values/${queryArg.id}/`,
        method: "PUT",
        body: queryArg.employeeRecordValueCreateUpdate,
      }),
    }),
    apiAdminV1EmployeeRecordValuesDestroy: build.mutation<
      ApiAdminV1EmployeeRecordValuesDestroyApiResponse,
      ApiAdminV1EmployeeRecordValuesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/admin/v1/employee-record-values/${queryArg.id}/`,
        method: "DELETE",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as adminApi };
export type ApiAdminV1EmployeeRecordValuesListApiResponse =
  /** status 200  */ EmployeeRecordValueRead[];
export type ApiAdminV1EmployeeRecordValuesListApiArg = {
  /** ID of the organization */
  organizationId?: number;
};
export type ApiAdminV1EmployeeRecordValuesCreateApiResponse =
  /** status 201  */ EmployeeRecordValueRead;
export type ApiAdminV1EmployeeRecordValuesCreateApiArg = {
  employeeRecordValueCreateUpdate: EmployeeRecordValueCreateUpdate;
};
export type ApiAdminV1EmployeeRecordValuesRetrieveApiResponse =
  /** status 200  */ EmployeeRecordValueRead;
export type ApiAdminV1EmployeeRecordValuesRetrieveApiArg = {
  /** A unique integer value identifying this employee record value. */
  id: number;
};
export type ApiAdminV1EmployeeRecordValuesUpdateApiResponse =
  /** status 200  */ EmployeeRecordValueRead;
export type ApiAdminV1EmployeeRecordValuesUpdateApiArg = {
  /** A unique integer value identifying this employee record value. */
  id: number;
  employeeRecordValueCreateUpdate: EmployeeRecordValueCreateUpdate;
};
export type ApiAdminV1EmployeeRecordValuesDestroyApiResponse =
  /** status 204  */ {
    [key: string]: any;
  };
export type ApiAdminV1EmployeeRecordValuesDestroyApiArg = {
  /** A unique integer value identifying this employee record value. */
  id: number;
};
export type EmployeeRecordValue = {
  id: number;
  name: string;
  type_of_value: number;
};
export type EmployeeRecordValueRead = {
  id: number;
  name: string;
  type_of_value: number;
  organization: string;
};
export type EmployeeRecordValueCreateUpdateTypeOfValueEnum =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 9
  | 11
  | 12;
export type EmployeeRecordValueCreateUpdate = {
  id?: number;
  name: string;
  type_of_value: EmployeeRecordValueCreateUpdateTypeOfValueEnum;
  organization: number;
};
export const {
  useApiAdminV1EmployeeRecordValuesListQuery,
  useApiAdminV1EmployeeRecordValuesCreateMutation,
  useApiAdminV1EmployeeRecordValuesRetrieveQuery,
  useApiAdminV1EmployeeRecordValuesUpdateMutation,
  useApiAdminV1EmployeeRecordValuesDestroyMutation,
} = injectedRtkApi;
